import React from "react";
import "./style.css";

export const Header = () => {
  return (
    <header className="header">
      <div className="logo-2">
        <img className="logo-3" alt="Logo" src="/img/logo-3-1.png" />

        <div className="text-wrapper-28">Build Start</div>
      </div>

      <div className="menu">
        <p className="home-owner-for">
          Home Owner&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          For Building
          Professionals&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Directory&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Pricing&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Info Guides
        </p>
      </div>

      <button className="btn">
        <div className="overlap-group-7">
          <div className="text-wrapper-29">Log In</div>
        </div>
      </button>

      <button className="button">
        <div className="overlap-13">
          <div className="text-wrapper-30">Register</div>
        </div>
      </button>
    </header>
  );
};
